import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import Heading from "Components/Heading";
import Footer from "Components/Footer";
import SampleDataTable from "Components/DataTables";
import DepartmentAPIs from "../../APIs/department";
import { toast } from "react-toastify";
import { Formik } from "formik";
import * as Yup from "yup";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";

const Department = () => {
  const [department, setDepartment] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'edit'
  const [currentEditItem, setCurrentEditItem] = useState(null);

  // To open modal in add mode
  const handleShowAdd = () => {
    setModalMode("add");
    setCurrentEditItem(null);
    setShowModal(true);
  };

  // To open modal in edit mode
  const handleShowEdit = (item) => {
    setModalMode("edit");
    setCurrentEditItem(item);
    setShowModal(true);
  };

  const editDepartment = async (data, resetForm) => {
    setIsLoading(true);
    try {
      // Assuming your API has an editDocTypeById method
      await DepartmentAPIs.updateDepartmentById(currentEditItem.id, data);
      toast.success("Department Updated Successfully.");
      setShowModal(false); // Close modal after submission
      getAllDepartment(); // Refresh the list
    } catch (error) {
      toast.error("Failed to update Department.");
    }
    setIsLoading(false);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Department Name. is required"),
  });

  const submitHandler = async (data, resetForm) => {
    setIsLoading(true);
    const res = await DepartmentAPIs.createDepartment(data);
    if (res) {
      toast.success("Department Added Successfully.");
      resetForm({ values: "" });
      setShowModal(false); // Close modal after submission
      getAllDepartment();
    }
    setIsLoading(false);
  };

  const getAllDepartment = async () => {
    const department = await DepartmentAPIs.getDepartments();
    if (department) {
      setDepartment(department.data.data);
    }
  };

  useEffect(() => {
    getAllDepartment();
  }, []);

  // Function to handle modal close
  const handleClose = () => setShowModal(false);
  // Function to handle modal show
  const handleShow = () => setShowModal(true);

  return (
    <>
      <section>
        <Heading text={"Department"} />
        <Card>
          <Button
            variant="primary"
            onClick={handleShowAdd}
            size="sm"
            style={{ width: "150px", marginBottom: "20px" }}
          >
            Add Department
          </Button>

          {/* Popup Add-Edit */}
          <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Add Department</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                onSubmit={(values, { resetForm }) => {
                  //submitHandler(values, resetForm);
                  if (modalMode === "add") {
                    submitHandler(values, resetForm); // Your existing add functionality
                  } else {
                    // Call edit API
                    editDepartment(values, resetForm);
                  }
                }}
                initialValues={{
                  name:
                    modalMode === "edit" && currentEditItem
                      ? currentEditItem.name
                      : "",
                }}
                validationSchema={validationSchema}
                validateOnChange={false}
              >
                {({ handleSubmit, handleChange, values, errors }) => (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Department Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        onChange={handleChange}
                        value={values.name}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="primary" type="submit">
                      Save Changes
                    </Button>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>
          {/* Listing Table */}
          <SampleDataTable
            columns={[
              { accessor: "name", Header: "Department" },
              {
                accessor: "id",
                Header: "Action",
                Cell: ({ row }) => (
                  <>
                    <Button
                      className="me-3"
                      onClick={() => handleShowEdit(row.original)}
                    >
                      <FaRegEdit />
                    </Button>
                    <Button
                      variant="danger"
                      className="me-3"
                      onClick={async () => {
                        const isConfirmed = window.confirm(
                          "Are you sure you want to delete this Department?"
                        );
                        if (isConfirmed) {
                          // Call delete API

                          setIsLoading(true);
                          try {
                            await DepartmentAPIs.deleteDepartmentById(
                              row.original.id
                            );
                            toast.success("Department Deleted Successfully.");
                            getAllDepartment(); // Refresh the list
                          } catch (error) {
                            toast.error("Failed to delete Department.");
                          }
                          setIsLoading(false);
                        }
                      }}
                    >
                      <FaRegTrashAlt />
                    </Button>
                  </>
                ),
              },
            ]}
            data={department}
          />
          <Footer />
        </Card>
      </section>
    </>
  );
};

export default Department;
